import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { addCompany } from '../store/actions/companies'
import CompanyLayout from '../layouts/Company/CompanyLayout'
import { HOME_PATH } from '../constants/routes'

const mapStateToProps = ({ companies: { isLoading } }, { history }) => ({
    isLoading,
    history,
})

const mapDispatchToProps = {
    addCompany,
}

const mergeProps = (
    { isLoading, history },
    { addCompany },
) => {
    return {
        isLoading,
        onSubmit: addCompany,
        onClose: () => history.push(HOME_PATH),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(CompanyLayout))



// WEBPACK FOOTER //
// ./src/containers/CompanyContainer.js